import React from 'react';
import { MdSearch } from 'react-icons/md';
import { FormField, FormFieldErrorHelp, FormFieldLabel, FormInputWithBtn, FormTextInput } from '@styled/Form';
function SearchInput(_a) {
    var label = _a.label, value = _a.value, name = _a.name, onChange = _a.onChange, css = _a.css, bottomMargin = _a.bottomMargin, invalid = _a.invalid, invalidString = _a.invalidString, placeholder = _a.placeholder;
    var isInvalid = invalidString && invalidString !== '' ? true : false;
    return (React.createElement(FormField, { style: css, "$bottomSpace": bottomMargin },
        label && React.createElement(FormFieldLabel, null, label),
        React.createElement(FormInputWithBtn, { "$invalid": isInvalid || invalid },
            React.createElement(MdSearch, { size: 20 }),
            React.createElement(FormTextInput, { type: "text", value: value, name: name, placeholder: placeholder, onChange: onChange })),
        isInvalid && React.createElement(FormFieldErrorHelp, null, invalidString)));
}
export default SearchInput;
